export const bankData = {
  "id": null,
  "bankName": null,
  "bankCode": null,
  "country": null,
  "accountNumber": null,
  "accountHolder": null,
}